import React from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import { parse, add, format } from 'date-fns'

function classNames(...classes) {return classes.filter(Boolean).join(' ')}

const TeacherCalendarMonthViewHeader = ({currentMonth, setCurrentMonth, setTeacherCalendarView, createANewCalendarEvent, setSelectedDay, teacherCalendarView, changeSelectedDay}) => {

    let firstDayOfCurrentMonth = parse(currentMonth, 'MMMM yyyy', new Date())

    const nextMonth = () => {
      let firstDayOfNextMonth = add(firstDayOfCurrentMonth, { months: 1})
      setCurrentMonth(format(firstDayOfNextMonth, 'MMMM yyyy'))
    }
  
    const prevMonth = () => {  
      let firstDayOfNextMonth = add(firstDayOfCurrentMonth, { months: -1})
      setCurrentMonth(format(firstDayOfNextMonth, 'MMMM yyyy'))
    }

    const chooseToday = () => {
      setCurrentMonth(format(new Date(), 'MMMM yyyy'))
      changeSelectedDay(format(new Date(), 'yyyy-MM-dd'))
    }

    return (
      <header className="border-b border-gray-200 py-4 px-1 lg:flex-none">
        <h1 className="text-3xl font-thin tracking-wide mt-1 mb-2 text-gray-900">
          <time dateTime="2022-01">{currentMonth}</time>
        </h1>
        <div className="flex items-center">
          <div className="flex items-center rounded-md shadow-sm md:items-stretch border border-solid border-gray-300">
            <button type="button" onClick={() => prevMonth()} className="flex items-center justify-center rounded-l-md border-0 bg-white py-2 pl-2 pr-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:px-2 md:hover:bg-gray-50">
              <span className="sr-only">Previous month</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </button>
            <button type="button" onClick={() => chooseToday()} className="border-0 bg-white px-3.5 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900 focus:relative md:block">
              Today
            </button>
            <span className="relative -mx-px h-5 w-px md:hidden" />
            <button type="button" onClick={() => nextMonth()} className="flex items-center justify-center rounded-r-md border-0 bg-white py-2 pl-1 pr-2 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:px-2 md:hover:bg-gray-50">
              <span className="sr-only">Next month</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
          <div className='ml-auto'>
                <div className='bg-gray-100 rounded-lg border border-solid border-gray-300'>
                  <div onClick={() => setTeacherCalendarView('day')} className={classNames(teacherCalendarView === 'day' && 'bg-white border border-solid border-gray-300 shadow-md', 'inline-block my-1 mx-2 font-md text-sm py-1 px-2 rounded-lg  cursor-pointer')}>Day</div>
                  <div onClick={() => setTeacherCalendarView('week')} className={classNames(teacherCalendarView === 'week' && 'bg-white border border-solid border-gray-300 shadow-md', 'inline-block my-1 mx-2 font-md text-sm py-1 px-2 rounded-lg cursor-pointer')}>Week</div>
                  <div onClick={() => setTeacherCalendarView('month')} className={classNames(teacherCalendarView === 'month' && 'bg-white border border-solid border-gray-300 shadow-md', 'inline-block my-1 mx-2 font-md text-sm py-1 px-2 rounded-lg cursor-pointer')}>Month</div>
                </div>
              </div>
        </div>
      </header>
    )
}
export default TeacherCalendarMonthViewHeader